<template>
  <div v-if="!isMobile" class="container-pc">
    <section id="hero">
      <div class="container">
        <div data-aos="zoom-out" class="text">
          <h1>
            {{ isCN ? "CHINA VALVE（HANGZHOU）" : "CHINA VALVE（HANGZHOU）" }}
          </h1>
          <h2>
            {{ isCN ? "2026年4月13-19日" : "APRIL 13-19, 2026" }}&nbsp;
            {{ isCN ? "中国杭州" : "HANGZHOU, CHINA" }}
          </h2>
          <div class="yy">
            {{ isCN ? "CHINA VALVE（HANGZHOU）" : "CHINA VALVE（HANGZHOU）" }}
          </div>
        </div>
        <div class="testimonials-slider swiper" data-aos="fade-up" data-aos-delay="100" style="overflow: hidden;">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="row">
                <div
                  class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                  style="justify-content: center"
                >
                  <div class="img-box" data-aos="zoom-out" data-aos-delay="100">
                    <img src="@/assets/img/slices/heroImg/hero-1.jpg" alt="" />
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                  style="justify-content: center"
                >
                  <div class="img-box" data-aos="zoom-out" data-aos-delay="200">
                    <img src="@/assets/img/slices/heroImg/hero-2.jpg" alt="" />
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                  style="justify-content: center"
                >
                  <div class="img-box" data-aos="zoom-out" data-aos-delay="300">
                    <img src="@/assets/img/slices/heroImg/hero-3.jpg" alt="" />
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                  style="justify-content: center"
                >
                  <div class="img-box" data-aos="zoom-out" data-aos-delay="400">
                    <img src="@/assets/img/slices/heroImg/hero-4.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="row">
                <div
                  class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                  style="justify-content: center"
                >
                  <div class="img-box" data-aos="zoom-out" data-aos-delay="100">
                    <img src="@/assets/img/slices/heroImg/hero-5.jpg" alt="" />
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                  style="justify-content: center"
                >
                  <div class="img-box" data-aos="zoom-out" data-aos-delay="200">
                    <img src="@/assets/img/slices/heroImg/hero-6.jpg" alt="" />
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                  style="justify-content: center"
                >
                  <div class="img-box" data-aos="zoom-out" data-aos-delay="300">
                    <img src="@/assets/img/slices/heroImg/hero-7.jpg" alt="" />
                  </div>
                </div>
                <div
                  class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                  style="justify-content: center"
                >
                  <div class="img-box" data-aos="zoom-out" data-aos-delay="400">
                    <img src="@/assets/img/slices/heroImg/hero-8.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <svg
        class="hero-waves"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28 "
        preserveAspectRatio="none"
      >
        <defs>
          <path
            id="wave-path"
            d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
          />
        </defs>
        <g class="wave1">
          <use
            xlink:href="#wave-path"
            x="50"
            y="3"
            fill="rgba(255,255,255, .1)"
          />
        </g>
        <g class="wave2">
          <use
            xlink:href="#wave-path"
            x="50"
            y="0"
            fill="rgba(255,255,255, .2)"
          />
        </g>
        <g class="wave3">
          <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
        </g>
      </svg>
    </section>

    <main id="main">
      <!-- ======= Featured Services Section ======= -->
      <section id="featured-services" class="featured-services">
        <div class="container" data-aos="fade-up">
          <div class="row gy-3">
            <div
                class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                @click="goSubmission(0)"
            >
              <div class="icon-box" data-aos="fade-up" data-aos-delay="300">
                <div class="icon">
                  <i class="bi bi-clipboard2-plus-fill"></i>
                </div>
                <h4 class="title">
                  <a>{{ isCN ? "2025年12月1日" : "December 1, 2025" }}</a>
                </h4>
                <p class="description">
                  {{ isCN ? "征文投稿" : "Call For Abstracts" }}
                </p>
              </div>
            </div>

             <div
                class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
                @click="goSubmission(1)"
            >
              <div class="icon-box" data-aos="fade-up" data-aos-delay="300">
                <div class="icon">
                  <i class="bi bi-clipboard2-plus-fill"></i>
                </div>
                <h4 class="title">
                  <a>{{ isCN ? "2025年12月1日" : "December 1, 2025" }}</a>
                </h4>
                <p class="description">
                  {{ isCN ? "病例投稿" : "Call For Cases" }}
                </p>
              </div>
            </div>
            
            
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              @click="goSignUp"
            >
              <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
                <div class="icon"><i class="bi bi-person-plus-fill"></i></div>
                <h4 class="title">
                  <a
                    >{{ isCN ? "2026年1月1日" : "January 1,2026" }}</a
                  >
                </h4>
                <p class="description">
                  {{ isCN ? "官网开放注册" : "Early-Bird Registration" }}
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
            >
              <div class="icon-box" data-aos="fade-up" data-aos-delay="300">
                <div class="icon">
                  <i class="bi bi-calendar2-event-fill"></i>
                </div>
                <h4 class="title">
                  <a href="https://www.drvoice.cn/v2/programme/1436107377877248">{{ isCN ? "2026年2月1日" : "February 1st,2026" }}</a>
                </h4>
                <p class="description">
                  <a style="color: black;" href="https://www.drvoice.cn/v2/programme/1436107377877248">
                  {{ isCN ? "日程一览" : "Program Overview" }}
                </a>
                </p>
              </div>
            </div>

              <!-- 
         <div
              style = "display: none;"
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
            >
              <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
                <div class="icon"><i class="bi bi-bookmark-plus-fill"></i></div>
                <h4 class="title">
                  <a>{{ isCN ? "2026年4月13日" : "April 13, 2026" }}</a
                  >
                </h4>
                <p class="description">
                  {{ isCN ? "会议开始" : "The Meeting Starts" }}
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
            >
              <div class="icon-box" data-aos="fade-up" data-aos-delay="400">
                <div class="icon">
                  <i class="bi bi-clipboard2-pulse-fill"></i>
                </div>
                <h4 class="title">
                  <a>{{ isCN ? "2026年4月19日" : "April 19,2026" }}</a>
                </h4>
                <p class="description">
                  {{ isCN ? "会议闭幕" : "Closing Ceremony" }}
                </p>
              </div>
            </div>-->
          </div>
        </div>
      </section>

      <section id="webinar-series" class="webinar-series">
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <h3>{{ isCN ? "Webinars" : "Webinars" }}</h3>
          </div>
          <a href="https://www.drvoice.cn/v2/course/3538" target="_blank">
            <div class="ws-box">
              <div class="ws-lt">
                <div class="ws-title">
                  CHINA VALVE – MOUNT SINAI Structural Heart Webinar
                </div>
                <div class="ws-subtitle">
                  Tailoring TEER therapy with MitraClip
                </div>
                <div class="ws-time"><span style="fontWeight:bold;">Time(CN): 2024-11-14 20:30 - 21:30</span></div>
              </div>
              <div class="ws-img">
                <img class="bg" src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2024/11/08/32af592736274ee88da9e11a2028168c.png" alt="">
                <img class="img" src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2024/11/08/32af592736274ee88da9e11a2028168c.png" alt="">
              </div>
            </div>
          </a>
        </div>
      </section>

      <!-- ======= About Section ======= -->
      <section id="about" class="about section-bg">
        <div class="container" data-aos="fade-up">
          <div class="section-title">
            <h3>{{ isCN ? "欢迎辞" : "Welcoming Speech" }}</h3>
          </div>

          <div class="row">
            <div
              data-aos="fade-up"
              data-aos-delay="100"
              class="col-lg-8 pt-4 pt-lg-0 content d-flex flex-column justify-content-center"
            >
              <template v-if="isCN">
                <p>尊敬的各位专家、各位同道：</p>
                <p style="text-indent: 2em;">
                  惠风和畅，万物并秀。
                </p>
                <p style="text-indent: 2em;">
                  在这充满希望与活力的美好时节，<span style="color: #17227c;">CHINA VALVE（HANGZHOU）2026</span>定于<span style="color: #17227c;">2026年4月13日-19日</span>在<span style="color: #17227c;">杭州</span>召开。我们满怀热忱，向您发出诚挚的邀请，期待与您共赴这场瓣膜介入领域的学术盛宴。
                </p>
                <template v-if="isAllText">
                  <p style="text-indent: 2em;">
                    自2015年启程，CHINA VALVE（HANGZHOU）已走过十一个春秋。去年，我们共同见证了诸多突破与创新，大会的每一场研讨、每一次手术演示，都为中国瓣膜事业注入新动力。在大家的支持下，我们持续深耕，推动中国瓣膜介入领域在国际舞台上绽放光彩，也让更多患者受益于前沿技术与理念。
                  </p>
                  <p style="text-indent: 2em;">
                    站在瓣膜介入领域飞速发展的当下，面对各种创新器械、创新技术、循证证据层出不穷的现状，CHINA VALVE (HANGZHOU) 2026将用心感知国内外瓣膜介入领域的发展潮流以及瓣膜介入术者们的成长需求，深度携手国际知名学术组织，汇聚全球范围内的顶尖专家，聚焦前沿热点话题，共同研讨新课题、发掘新机遇，传播和展示近年来世界瓣膜介入领域发展全貌。
                  </p>
                  <p style="text-indent: 2em;">
                    同时，本届大会进一步关注<span style="color: #17227c;">临床研究，集合手术演示、病例分享、主旨演讲、论文竞赛</span>等多元形式，为广大参会者搭建技术学习和精进的平台；招牌栏目<span style="color: #17227c;">全球/全国手术联播版块</span>，演示范围涵盖主动脉瓣、二尖瓣、三尖瓣等结构性心脏病介入全领域，直观展示最前沿的实操理念；<span style="color: #17227c;">Case-Based Learning、Step by Step Learning</span>等专场，介入“高手”手把手传经送宝；<span style="color: #17227c;">Workshop版块</span>上VR操作、实体猪心解剖、模拟器等“神器”将轮番出场，打造沉浸式实操演练“训练场”；<span style="color: #17227c;">超声与CT版块</span>以临床为导向，打造话题更聚焦的特色专场，以互动教学的模式精准传授实用技能；<span style="color: #17227c;">基础转化论坛</span>进一步关注基础与应用研究，为跨界思辨提供“舞台”，赋能临床成果转化；除此以外，还有众多主题专场将带来精彩纷呈的学术内容，竭尽全力为广大参会者带来一场实用、前沿、国际、专业的学术盛宴，点亮每一位参会者的求知之路。
                  </p>
                  <p style="text-indent: 2em;">
                    春启华筵，柳扬燕归赴新程。正如花朵等待于春日绽放，CHINA VALVE（HANGZHOU）也以春为信，以“瓣膜”为名，热忱地向您发出邀请，无论您是经验丰富的医学大家、朝气蓬勃的后起之秀，还是懵懵懂懂的介入“小白”，都欢迎您加入这场春天里的学术之约，共同为瓣膜介入医学的辉煌未来奋勇前进。
                  </p>
                  <p style="text-indent: 2em;">
                    CHINA VALVE（HANGZHOU）2026期待与您相聚杭州，欢迎您的到来！
                  </p>
                </template>
              </template>
              <template v-else>
                <p>Distinguished experts and colleagues,</p>
                <p class="p-section">
                  The ages resemble monuments, on which time leaves its prints as annual rings. The annual CHINA VALVE (HANGZHOU) will once again take place in Hangzhou from April 13th to April 19th , 2026, when the warm spring breeze blows across the banks of the Qianjiang River. Here, we cordially welcome all specialists to take part in this academic gathering!
                </p>
                <template v-if="isAllText">
                  <p class="p-section">
                    As usual, this conference will collaborate with globally recognized academic institutions, convene top professionals, and exceptional discipline leaders in the field of structural and valvular heart disease to talk about the future of the field. Based on the mastery of transcatheter aortic valve replacement (TAVR), the conference will explore the frontiers of transcatheter mitral valve repair/replacement (TMVr/R), transcatheter tricuspid valve repair/replacement (TTVr/R), and transcatheter pulmonary valve replacement (TPVR) through the Global & National Live Demos. We will also comprehensively demonstrate the most cutting-edge diagnosis and treatment instruments, concepts, and technologies in the world. The conference provides programs like Learn from Masters, Case-Based Learning, and specialized seminars on anatomy, CT, and vascular staplers. More importantly, there will be academic presentations on cardiac ultrasound, anesthesia, and fundamental research. For centers intending to do valvular intervention, the conference will offer methodical training; for newly formed centers, it will offer technical enhancements; and for established centers, it will offer opportunities for cooperation and experience sharing. The conference's overall goal is to establish a global, elite, diverse, and open-access platform for participating physicians.
                  </p>
                  <p class="p-section">
                    Time marches on, just like the seasons change. The events of the previous decade still seem like they happened yesterday while a new decade has already begun. With the commitment to strive for a better future, CHINA VALVE (HANGZHOU) 2026 will continue to think deeply and pursue technological advancements by asking valuable questions, making thoughtful observations and applying analytical discernment so as to open a new chapter of amazing academic exchanges in valve disease diagnosis and treatment.
                  </p>
                  <p class="p-section">
                    We sincerely thank each and every one of our colleagues for their unwavering enthusiasm and support, and we hope that all experts and colleagues will be able to attend the conference despite their hectic schedules. We look forward to seeing you in Hangzhou in the spring time of April to accelerate the advancement of China valve!
                  </p>
                </template>
              </template>
              <!-- <div class="about-bottom" v-if="!isAllText">
                <div class="rt-btn" @click="isAllText = true">
                  {{ isCN ? "查看更多" : "read more" }}
                </div>
              </div> -->
            </div>
            <div class="col-lg-4 pt-4 pt-lg-0">
              <img style="width: 100%;border-radius: 8px;" src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/01/02/f1a565bdf3db4870b4b4caed82a0cb39.jpg" alt="">
              <div class="sign-list" style="margin-top: 12px;display: flex;justify-content: center" v-if="isAllText">
                <div class="sign-img">
                  <div
                    style="
                      display: flex;
                      flex: 1;
                      flex-direction: column;
                      justify-content: center;
                      align-items: center;
                    "
                  >
                    <img
                      src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2023/02/15/bf3e09ad8d7543118e2fa879c702ba28.png"
                    />
                  </div>
                  <div>{{ isCN ? "王建安" : `Jian'an Wang` }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- ======= Services Section ======= -->
      <section id="previews" class="previews">
        <div class="container" data-aos="fade-up" data-aos-delay="200">
          <div class="section-title">
            <h3>{{ isCN ? "会议亮点" : "Conference Highlights" }}</h3>
          </div>
          <div class="row">
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              style="justify-content: center"
            >
              <div class="CH-card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/ecbccc02f07d46ca8ee60e7ce0518737.png" alt="" />
                <h4>{{ isCN ? "携手国际顶刊" : "Partner Up With World-Leading Journals" }}</h4>
                <p v-if="isCN">与JACC系列期刊联合征稿，打造学术成果展示高地</p>
                <p v-else>
                  Call for paper in conjunction with the JACC journal family, Sharing pioneering academic outcomes on elite platforms
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              style="justify-content: center"
            >
              <div class="CH-card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/aad6e509a83e45cda28f932f6b004f91.png" alt="" />
                <h4>
                  {{
                    isCN ? "全球/全国手术联播" : "Global/National Live Operations"
                  }}
                </h4>
                <p v-if="isCN">汇聚全球“高手”，展示全球最前沿技术和器械</p>
                <p v-else>
                  Bringing together masters from around the globe/ Global master gathering, Showcasing next generation technology and devices
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              style="justify-content: center"
            >
              <div class="CH-card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/74468e3f84464a6e8a76b2349e1ff6bf.png" alt="" />
                <h4>{{ isCN ? "内外科碰撞与融合" : "Dismantling The Cardiac And Cardiology Barrier For A Future Of Fusion /Clash And Convergence Between Cardiac And Cardiology" }}</h4>
                <p v-if="isCN">心内×心外科同台对话，破解治疗“选择题”</p>
                <p v-else>
                  Cardiologist & Cardiac Surgeon Face to Face, Resolving dilemma in the treatment course
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              style="justify-content: center"
            >
              <div class="CH-card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/ceab95f1f4c14be5b2a547537c32db6a.png" alt="" />
                <h4>{{ isCN ? "经血管植入器械全国重点实验室" : "National Key Lab For Trans-catheter Devices" }}</h4>
                <p v-if="isCN">医工信交叉融合，直击医疗器械创新链最前沿</p>
                <p v-else>
                  Fusing medicine, engineering and information, Pushing the envelop of medical device innovation
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              style="justify-content: center"
            >
              <div class="CH-card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/a0c85de0a8a14c448342fb526629fcf5.jpg" alt="" />
                <h4>{{ isCN ? "超人来了·TEER全能术者大赛" : "Meet The Ultra-Operator - Full-Stack TEER Master Tournament" }}</h4>
                <p v-if="isCN">三重关卡挑战，寻找集手术实操+影像解读于一身的“六边形全能术者”</p>
                <p v-else>
                  Looking for the full-stack TEER Triathlon, Come and showcase your outstanding operating and imaging expertise
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              style="justify-content: center"
            >
              <div class="CH-card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/c0182cf052ce4dea85f6ad2485669ba6.png" alt="" />
                <h4>{{ isCN ? "多维实战工坊" : "All-Round Hands-On Workshop" }}</h4>
                <p v-if="isCN">CME二尖瓣继续教育专场、Workshop，从实战到理论学习全方位</p>
                <p v-else>
                  Mitral valve CME Lectures and Workshops, Full-spectrum training for practical and theoretical deep dive
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              style="justify-content: center"
            >
              <div class="CH-card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/fe286c222745431bba0e9a220c466869.png" alt="" />
                <h4>
                  {{
                    isCN
                      ? "AI融合新趋势"
                      : "Exploring The AI + New Frontier"
                  }}
                </h4>
                <p v-if="isCN">人机协同、影像 + AI ，探索AI辅助医疗的最佳模式</p>
                <p v-else>
                  Human-machine collaboration, Imaging+AI, Exploring the optimal solution for AI-assisted medicine
                </p>
              </div>
            </div>
            <div
              class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0"
              style="justify-content: center"
            >
              <div class="CH-card" data-aos="fade-up" data-aos-delay="400">
                <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/2e18afd8fc4a4b30b25303b70bd9b0c6.png" alt="" />
                <h4>{{ isCN ? "多元学习平台" : "Comprehensive Learning Platform /Multidisciplinary Learning Platform" }}</h4>
                <p v-if="isCN">覆盖基础、影像、心超、护理等多领域</p>
                <p v-else>
                  Covering multiple areas of expertise from basic science (basic medicine) to imaging, echocardiogram, nursing and beyond
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- ======= Footer ======= -->
    <footer id="footer" class="footer">
      <div class="container" data-aos="fade-up">
        <div class="section-title">
          <h3>{{ isCN ? "联系我们" : "Contact Us" }}</h3>
        </div>
        <div class="row">
          <div class="hosted">
            <h5>{{ isCN ? "主办单位" : "HOSTED BY" }}</h5>
            <p>
              {{
                isCN
                  ? "浙江大学医学院附属第二医院"
                  : "Second Affiliated Hospital, Zhejiang University School of Medicine (SAHZU)"
              }}
              <br />
              <a href="https://www.csi-congress.org/" target="_blank" style="color:#2D2D2D;">
                {{
                  isCN
                    ? "结构性心脏大会CSI"
                    : "Catheter Interventions in Congenital, Structural and Valvular Heart Diseases (CSI)"
                }}
              </a>
              <br />
              <a href="https://www.smidf.org.cn/" target="_blank" style="color:#2D2D2D;">
                {{
                  isCN
                      ? "上海医学创新发展发展基金会"
                      : "Shanghai Medical Innovation & Development Foundation"
                }}
              </a>
            </p>
          </div>
          <div class="foot-bottom">
            <div class="tp">
              <div class="foot-item">
                <div class="icon"><i class="bi bi-calendar2-check"></i></div>
                <div class="item-rt">
                  <h5>{{ isCN ? "会议时间：" : "CONFERENCE DATES" }}</h5>
                  <p>
                    {{
                      isCN
                        ? "2026年4月13-19日"
                        : "April.13, 2026- April.19, 2026"
                    }}
                  </p>
                </div>
              </div>
              <div class="foot-item">
                <div class="icon"><i class="bi bi-globe2"></i></div>
                <div class="item-rt">
                  <h5>{{ isCN ? "大会官网：" : "WEBSITE" }}</h5>
                  <p>http://www.china-valve.org.cn</p>
                </div>
              </div>
            </div>
            <div class="bt">
              <template v-if="isCN">
                <div class="foot-item">
                  <div class="icon"><i class="bi bi-envelope"></i></div>
                  <div class="item-rt">
                    <h5>联系方式</h5>
                    <p>
                      13805784967
                      <br/>
                      cvh2026@china-valve.org.cn
                    </p>
                  </div>
                </div>
                <div class="foot-item">
                  <div class="icon"><i class="bi bi-geo-alt"></i></div>
                  <div class="item-rt">
                    <h5>会场地点</h5>
                    <p style="font-size:15px">
                      杭州
                    </p>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="foot-item">
                  <div class="icon"><i class="bi bi-telephone"></i></div>
                  <div class="item-rt">
                    <h5>{{ isCN ? "会务组联系电话：" : "CONTACT" }}</h5>
                    <p>
                      {{
                        isCN ? "13805784967" : "+86 13805784967"
                      }}
                    </p>
                  </div>
                </div>
                <div class="foot-item">
                  <div class="icon"><i class="bi bi-envelope"></i></div>
                  <div class="item-rt">
                    <h5>{{ isCN ? "电子邮箱：" : "EMAIL" }}</h5>
                    <p>cvh2026@china-valve.org.cn</p>
                  </div>
                </div>
              </template>
            </div>

            <div class="bt">
              <a href="https://www.csi-congress.org/" target="_black" class="foot-item">
                <div class="icon" style="padding-top:29px">
                  <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2024/05/13/f0232c8af9eb4ef9b9523856675a7cd4.png" width="50px" height="50px" style="vertical-align:top">
                </div>
                <div class="item-rt">
                  <h5>{{ isCN ? "合作伙伴" : "PARTNER" }}</h5>
                  <p>
                    CSI:  &nbsp;<span style="text-decoration: underline;">https://www.csi-congress.org/</span>
                  </p>
                </div>
              </a>
            </div>

          </div>
        </div>
      </div>
      <div style="text-align: center">
        <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #aaa"
          >京ICP备15021671号-3</a
        >
      </div>
    </footer>
    <a
      href="#"
      class="back-to-top d-flex align-items-center justify-content-center"
    >
      <i class="bi bi-arrow-up-short"></i>
    </a>
  </div>
  <div v-else class="container-mb">
    <div class="main">
      <section id="hero">
        <div class="container">
          <div
            class="col-lg-7 pt-lg-0 order-2 order-lg-1 d-flex align-items-center"
          >
            <div data-aos="zoom-out" class="text">
              <h1>
                {{
                  isCN ? "CHINA VALVE（HANGZHOU）" : "CHINA VALVE（HANGZHOU）"
                }}
              </h1>
              <h2>
                {{ isCN ? "2026年4月13-19日" : "APRIL 13-19, 2026" }}&nbsp;
                {{ isCN ? "中国杭州" : "HANGZHOU, CHINA" }}
              </h2>
              <div class="yy">
                {{
                  isCN ? "CHINA VALVE（HANGZHOU）" : "CHINA VALVE（HANGZHOU）"
                }}
              </div>
            </div>
          </div>
          <div class="box">
            <div class="img-list">
              <div class="img-box" data-aos="zoom-out" data-aos-delay="100">
                <img src="@/assets/img/slices/heroImg/hero-1.jpg" alt="" />
              </div>
              <div class="img-box" data-aos="zoom-out" data-aos-delay="200">
                <img src="@/assets/img/slices/heroImg/hero-2.jpg" alt="" />
              </div>
              <div class="img-box" data-aos="zoom-out" data-aos-delay="300">
                <img src="@/assets/img/slices/heroImg/hero-3.jpg" alt="" />
              </div>
              <div class="img-box" data-aos="zoom-out" data-aos-delay="400">
                <img src="@/assets/img/slices/heroImg/hero-4.jpg" alt="" />
              </div>
              <div class="img-box" data-aos="zoom-out" data-aos-delay="500">
                <img src="@/assets/img/slices/heroImg/hero-5.jpg" alt="" />
              </div>
              <div class="img-box" data-aos="zoom-out" data-aos-delay="600">
                <img src="@/assets/img/slices/heroImg/hero-6.jpg" alt="" />
              </div>
              <div class="img-box" data-aos="zoom-out" data-aos-delay="700">
                <img src="@/assets/img/slices/heroImg/hero-7.jpg" alt="" />
              </div>
              <div class="img-box" data-aos="zoom-out" data-aos-delay="800">
                <img src="@/assets/img/slices/heroImg/hero-8.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <svg
          class="hero-waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28 "
          preserveAspectRatio="none"
        >
          <defs>
            <path
              id="wave-path"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g class="wave1">
            <use
              xlink:href="#wave-path"
              x="50"
              y="3"
              fill="rgba(255,255,255, .1)"
            />
          </g>
          <g class="wave2">
            <use
              xlink:href="#wave-path"
              x="50"
              y="0"
              fill="rgba(255,255,255, .2)"
            />
          </g>
          <g class="wave3">
            <use xlink:href="#wave-path" x="50" y="9" fill="#fff" />
          </g>
        </svg>
      </section>
      <div class="programe" id="featured-services" data-aos="fade-up">
        <div class="programe-item" @click="goSubmission(0)">
          <div class="lt">
            <div class="item-time">
              {{ isCN ? "2025年12月1日" : "December 1, 2025" }}
            </div>
            <div class="item-text">
              {{ isCN ? "征文投稿" : "Call For Abstracts" }}
            </div>
          </div>
          <div class="icon"><i class="bi bi-clipboard2-plus-fill"></i></div>
        </div>
        <div class="programe-item" @click="goSubmission(1)">
          <div class="lt">
            <div class="item-time">
              {{ isCN ? "2025年12月01日" : "December 01, 2025" }}
            </div>
            <div class="item-text">
              {{ isCN ? "病例投稿" : "Call For Cases" }}
            </div>
          </div>
          <div class="icon"><i class="bi bi-clipboard2-plus-fill"></i></div>
        </div>
        <div class="programe-item" @click="goSignUp">
          <div class="lt">
            <div class="item-time">
              {{ isCN ? "2026年1月1日" : "January 1,2026" }}
            </div>
            <div class="item-text">
              {{ isCN ? "官网开放注册" : "Early-Bird Registration" }}
            </div>
          </div>
          <div class="icon"><i class="bi bi-person-plus-fill"></i></div>
        </div>
        <div
          class="programe-item">
          <div class="lt">
            <a style="color:black;" href="https://www.drvoice.cn/v2/programme/1436107377877248">
            <div class="item-time">
              {{ isCN ? "2026年2月1日" : "February 1st,2026" }}
            </div>
            <div class="item-text">
              {{ isCN ? "日程一览" : "Program Overview" }}
            </div>
             </a>
          </div>

          <div class="icon"><i class="bi bi-bookmark-plus-fill"></i></div>
        </div>
        <div class="programe-item">
          <div class="lt">
            
            <div class="item-time">
              {{ isCN ? "2026年4月13日" : "April 13, 2026" }}
            </div>
            <div class="item-text">
              {{ isCN ? "会议开始" : "The meeting starts" }}
            </div>
         
          </div>
          <div class="icon"><i class="bi bi-calendar2-event-fill"></i></div>
        </div>
<!--        <div class="programe-item">
          <div class="lt">
            <div class="item-time">
              {{ isCN ? "2026年4月19日" : "April 19,2026" }}
            </div>
            <div class="item-text">
              {{ isCN ? "会议闭幕" : "Closing Ceremony" }}
            </div>
          </div>
          <div class="icon"><i class="bi bi-clipboard2-pulse-fill"></i></div>
        </div>-->
      </div>
      <div class="welcoming" id="about" data-aos="fade-up">
        <div class="mb-title">{{ isCN ? "欢迎辞" : "WELCOMING SPEECH" }}</div>
        <div class="" :class="{ isfold: isfold }" style="width: 100%">
           <template v-if="isCN">
            <div class="p">尊敬的各位专家、各位同道：</div>
            <div class="p">惠风和畅，万物并秀。</div>
            <div class="p">
              在这充满希望与活力的美好时节，<span style="color: #17227c;">CHINA VALVE（HANGZHOU）2026</span>定于<span style="color: #17227c;">2026年4月13日-19日</span>在<span style="color: #17227c;">杭州</span>召开。我们满怀热忱，向您发出诚挚的邀请，期待与您共赴这场瓣膜介入领域的学术盛宴。
            </div>
            <div class="p">
              自2015年启程，CHINA VALVE（HANGZHOU）已走过十一个春秋。去年，我们共同见证了诸多突破与创新，大会的每一场研讨、每一次手术演示，都为中国瓣膜事业注入新动力。在大家的支持下，我们持续深耕，推动中国瓣膜介入领域在国际舞台上绽放光彩，也让更多患者受益于前沿技术与理念。
            </div>
            <template v-if="isAllText">
              <div class="p">
                站在瓣膜介入领域飞速发展的当下，面对各种创新器械、创新技术、循证证据层出不穷的现状，CHINA VALVE (HANGZHOU) 2026将用心感知国内外瓣膜介入领域的发展潮流以及瓣膜介入术者们的成长需求，深度携手国际知名学术组织，汇聚全球范围内的顶尖专家，聚焦前沿热点话题，共同研讨新课题、发掘新机遇，传播和展示近年来世界瓣膜介入领域发展全貌。
              </div>
              <div class="p">
                同时，本届大会进一步关注<span style="color: #17227c;">临床研究，集合手术演示、病例分享、主旨演讲、论文竞赛</span>等多元形式，为广大参会者搭建技术学习和精进的平台；招牌栏目<span style="color: #17227c;">全球/全国手术联播版块</span>，演示范围涵盖主动脉瓣、二尖瓣、三尖瓣等结构性心脏病介入全领域，直观展示最前沿的实操理念；<span style="color: #17227c;">Case-Based Learning、Step by Step Learning</span>等专场，介入“高手”手把手传经送宝；<span style="color: #17227c;">Workshop版块</span>上VR操作、实体猪心解剖、模拟器等“神器”将轮番出场，打造沉浸式实操演练“训练场”；<span style="color: #17227c;">超声与CT版块</span>以临床为导向，打造话题更聚焦的特色专场，以互动教学的模式精准传授实用技能；<span style="color: #17227c;">基础转化论坛</span>进一步关注基础与应用研究，为跨界思辨提供“舞台”，赋能临床成果转化；除此以外，还有众多主题专场将带来精彩纷呈的学术内容，竭尽全力为广大参会者带来一场实用、前沿、国际、专业的学术盛宴，点亮每一位参会者的求知之路。
              </div>
              <div class="p">
                春启华筵，柳扬燕归赴新程。正如花朵等待于春日绽放，CHINA VALVE（HANGZHOU）也以春为信，以“瓣膜”为名，热忱地向您发出邀请，无论您是经验丰富的医学大家、朝气蓬勃的后起之秀，还是懵懵懂懂的介入“小白”，都欢迎您加入这场春天里的学术之约，共同为瓣膜介入医学的辉煌未来奋勇前进。
              </div>
              <div class="p">
                CHINA VALVE（HANGZHOU）2026期待与您相聚杭州，欢迎您的到来！
              </div>
            </template>
          </template>
          <template v-else>
            <div class="p">Distinguished experts and colleagues,</div>
            <div class="p">
              The ages resemble monuments, on which time leaves its prints as annual rings. The annual CHINA VALVE (HANGZHOU) will once again take place in Hangzhou from April 13th to April 19th , 2026, when the warm spring breeze blows across the banks of the Qianjiang River. Here, we cordially welcome all specialists to take part in this academic gathering!
            </div>
            <div class="p">
              As usual, this conference will collaborate with globally recognized academic institutions, convene top professionals, and exceptional discipline leaders in the field of structural and valvular heart disease to talk about the future of the field. Based on the mastery of transcatheter aortic valve replacement (TAVR), the conference will explore the frontiers of transcatheter mitral valve repair/replacement (TMVr/R), transcatheter tricuspid valve repair/replacement (TTVr/R), and transcatheter pulmonary valve replacement (TPVR) through the Global & National Live Demos. We will also comprehensively demonstrate the most cutting-edge diagnosis and treatment instruments, concepts, and technologies in the world. The conference provides programs like Learn from Masters, Case-Based Learning, and specialized seminars on anatomy, CT, and vascular staplers. More importantly, there will be academic presentations on cardiac ultrasound, anesthesia, and fundamental research. For centers intending to do valvular intervention, the conference will offer methodical training; for newly formed centers, it will offer technical enhancements; and for established centers, it will offer opportunities for cooperation and experience sharing. The conference's overall goal is to establish a global, elite, diverse, and open-access platform for participating physicians.
            </div>
            <div class="p">
              Time marches on, just like the seasons change. The events of the previous decade still seem like they happened yesterday while a new decade has already begun. With the commitment to strive for a better future, CHINA VALVE (HANGZHOU) 2026 will continue to think deeply and pursue technological advancements by asking valuable questions, making thoughtful observations and applying analytical discernment so as to open a new chapter of amazing academic exchanges in valve disease diagnosis and treatment.
            </div>
            <div class="p">
              We sincerely thank each and every one of our colleagues for their unwavering enthusiasm and support, and we hope that all experts and colleagues will be able to attend the conference despite their hectic schedules. We look forward to seeing you in Hangzhou in the spring time of April to accelerate the advancement of China valve!
            </div>
          </template>
        </div>
        <div class="switch" v-if="isfold" @click="isfold = false">
          {{ isCN ? "查看更多" : "MORE" }}
          <br />
          <i class="bi bi-chevron-down"></i>
        </div>
        <img v-if="!isfold" style="width: 80%;border-radius: 8px;display: block;margin: 0 auto;" src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/01/02/f1a565bdf3db4870b4b4caed82a0cb39.jpg" alt="">
        <div class="sign-list" style="margin: 12px 0;display: flex;justify-content: center" v-if="!isfold">
<!--          <div class="sign-img">-->
<!--            <div-->
<!--              style="-->
<!--                display: flex;-->
<!--                flex: 1;-->
<!--                flex-direction: column;-->
<!--                justify-content: center;-->
<!--                align-items: center;-->
<!--              "-->
<!--            >-->
<!--              <img-->
<!--                src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2023/02/21/1a95a989ad4749ae891bb7adcdca51c8.png"-->
<!--              />-->
<!--            </div>-->
<!--            <div>{{ isCN ? "葛均波" : "Jun-bo GE" }}</div>-->
<!--          </div>-->
          <div class="sign-img">
            <div
              style="
                display: flex;
                flex: 1;
                flex-direction: column;
                justify-content: center;
                align-items: center;
              "
            >
              <img
                src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2023/02/15/bf3e09ad8d7543118e2fa879c702ba28.png"
              />
            </div>
            <div>{{ isCN ? "王建安" : `Jian'an Wang` }}</div>
          </div>
<!--          <div class="sign-img">-->
<!--            <div-->
<!--              style="-->
<!--                display: flex;-->
<!--                flex: 1;-->
<!--                flex-direction: column;-->
<!--                justify-content: center;-->
<!--                align-items: center;-->
<!--              "-->
<!--            >-->
<!--              <img-->
<!--                src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2023/02/21/b487d0cf31df4d3180f41528b6064d66.png"-->
<!--              />-->
<!--            </div>-->
<!--            <div>Horst Sievert</div>-->
<!--          </div>-->
        </div>
      </div>
      <div
        class="previews"
        id="previews"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div class="mb-title">
          {{ isCN ? "会议亮点" : "Conference Highlights" }}
        </div>
        <div class="previews-list">
          <div class="previews-item">
            <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/ecbccc02f07d46ca8ee60e7ce0518737.png" alt="" />
            <h4>{{ isCN ? "携手国际顶刊 " : "Partner Up With World-Leading Journals" }}</h4>
            <p v-if="isCN">与JACC系列期刊联合征稿，打造学术成果展示高地</p>
            <p v-else>
              Gather world-renowned interventional cardiologist，impart professional knowledge, and resolve doubts
            </p>
          </div>
          <div class="previews-item">
            <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/aad6e509a83e45cda28f932f6b004f91.png" alt="" />
            <h4>
              {{
                isCN ? "全球/全国手术联播" : "Global/National Live Operations"
              }}
            </h4>
            <p v-if="isCN">汇聚全球“高手”，展示全球最前沿技术和器械</p>
            <p v-else>
              Bringing together masters from around the globe/ Global master gathering, Showcasing next generation technology and devices
            </p>
          </div>
          <div class="previews-item">
            <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/74468e3f84464a6e8a76b2349e1ff6bf.png" alt="" />
            <h4>{{ isCN ? "内外科碰撞与融合" : "Dismantling The Cardiac And Cardiology Barrier For A Future Of Fusion /Clash And Convergence Between Cardiac And Cardiology" }}</h4>
            <p v-if="isCN">心内×心外科同台对话，破解治疗“选择题”</p>
            <p v-else>
              Cardiologist & Cardiac Surgeon Face to, Resolving dilemma in the treatment course
            </p>
          </div>
          <div class="previews-item">
            <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/ceab95f1f4c14be5b2a547537c32db6a.png" alt="" />
            <h4>{{ isCN ? "经血管植入器械全国重点实验室" : "National Key Lab For Trans-catheter Devices" }}</h4>
            <p v-if="isCN">医工信交叉融合，直击医疗器械创新链最前沿</p>
            <p v-else>
              Fusing medicine, engineering and information, Pushing the envelop of medical device innovation
            </p>
          </div>
          <div class="previews-item">
            <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/a0c85de0a8a14c448342fb526629fcf5.jpg" alt="" />
            <h4>{{ isCN ? "超人来了·TEER全能术者大赛" : "Meet The Ultra-Operator - Full-Stack TEER Master Tournament" }}</h4>
            <p v-if="isCN">三重关卡挑战，寻找集手术实操+影像解读于一身的“六边形全能术者”</p>
            <p v-else>
              Looking for the full-stack TEER, Come and showcase your outstanding operating and imaging expertise
            </p>
          </div>
          <div class="previews-item">
            <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/c0182cf052ce4dea85f6ad2485669ba6.png" alt="" />
            <h4>{{ isCN ? "多维实战工坊" : "All-Round Hands-On Workshop" }}</h4>
            <p v-if="isCN">CME二尖瓣继续教育专场、Workshop，从实战到理论学习全方位</p>
            <p v-else>
              Mitral valve CME Lectures and Workshops, Full-spectrum training for practical and theoretical deep dive
            </p>
          </div>
          <div class="previews-item">
            <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/fe286c222745431bba0e9a220c466869.png" alt="" />
            <h4>
              {{
                isCN
                  ? "AI融合新趋势"
                  : "Exploring The AI + New Frontier"
              }}
            </h4>
            <p v-if="isCN">人机协同、影像 + AI ，探索AI辅助医疗的最佳模式</p>
            <p v-else>
              Human-machine collaboration, Imaging+AI, Exploring the optimal solution for AI-assisted medicine
            </p>
          </div>
          <div class="previews-item">
            <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2025/03/07/2e18afd8fc4a4b30b25303b70bd9b0c6.png" alt="" />
            <h4>{{ isCN ? "多元学习平台" : "Comprehensive Learning Platform /Multidisciplinary Learning Platform" }}</h4>
            <p v-if="isCN">覆盖基础、影像、心超、护理等多领域</p>
            <p v-else>
              Covering multiple areas of expertise from basic science (basic medicine) to imaging, echocardiogram, nursing and beyond
            </p>
          </div>
        </div>
      </div>
    </div>
    <footer id="footer">
      <div class="container" data-aos="fade-up">
        <div class="mb-title">{{ isCN ? "联系我们" : "Contact Us" }}</div>
        <div class="row">
          <div class="hosted">
            <h5>{{ isCN ? "主办单位" : "HOSTED BY" }}</h5>
            <p>
              {{
                isCN
                  ? "浙江大学医学院附属第二医院"
                  : "Second Affiliated Hospital, Zhejiang University School of Medicine (SAHZU)"
              }}
              <br />
              {{
                isCN
                  ? "结构性心脏大会CSI"
                  : "Catheter Interventions in Congenital, Structural and Valvular Heart Diseases (CSI)"
              }}
            </p>
          </div>
          <div class="foot-bottom">
            <div class="white">
              <div class="foot-item">
                <div class="icon"><i class="bi bi-calendar2-check"></i></div>
                <div class="item-rt">
                  <h5>{{ isCN ? "会议时间：" : "CONFERENCE DATES" }}</h5>
                  <p>
                    {{
                      isCN
                        ? "2026年4月13-19日"
                        : "April.13, 2026- April.19, 2026"
                    }}
                  </p>
                </div>
              </div>
              <div class="foot-item">
                <div class="icon"><i class="bi bi-globe2"></i></div>
                <div class="item-rt">
                  <h5>{{ isCN ? "大会官网：" : "WEBSITE" }}</h5>
                  <p>http://www.china-valve.org.cn</p>
                </div>
              </div>
              <div class="foot-item">
                <div class="icon"><i class="bi bi-telephone"></i></div>
                <div class="item-rt">
                  <h5>{{ isCN ? "会务组联系电话：" : "CONTACT" }}</h5>
                  <p>
                    {{
                      isCN ? "13805784967" : "+86 13805784967"
                    }}
                  </p>
                </div>
              </div>
              <div class="foot-item">
                <div class="icon"><i class="bi bi-envelope"></i></div>
                <div class="item-rt">
                  <h5>{{ isCN ? "电子邮箱：" : "EMAIL" }}</h5>
                  <p>cvh2026@china-valve.org.cn</p>
                </div>
              </div>
              <div v-if="isCN" class="foot-item">
                <div class="icon"><i class="bi bi-geo-alt"></i></div>
                <div class="item-rt">
                  <h5>会场地点</h5>
                  <p>杭州</p>
                </div>
              </div>
              <div class="bt">
                <a href="https://www.csi-congress.org/" target="_black" class="foot-item">
                  <div class="icon">
                    <img src="https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2024/05/13/f0232c8af9eb4ef9b9523856675a7cd4.png" width="50px" height="50px" style="vertical-align:top">
                  </div>
                  <div class="item-rt">
                    <h5>{{ isCN ? "合作伙伴" : "PARTNER" }}</h5>
                    <p>
                      CSI:  &nbsp;<span style="text-decoration: underline;">https://www.csi-congress.org/</span>
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { selectEl, onscroll } from "../utils/util";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import AOS from "aos";
import "aos/dist/aos.css";
import "../assets/css/bootstrap-utilities.css";
import {initWeChatForwardConfiguration} from "@/utils/weChatForward";

export default {
  name: "Home",
  data() {
    return {
      isMobile: "",
      isfold: true,
      isAllText: true,
    };
  },
  created() {
    initWeChatForwardConfiguration("CHINA VALVE（HANGZHOU）2026", window.location.href, "", "2026年4月13-19日 中国·杭州")

    const mobileAgent = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    const mobileTouch = "ontouchstart" in document.documentElement;
    const mobileMedia = window.matchMedia(
      "only screen and (max-width: 767px)"
    ).matches;
    this.isMobile = !!(mobileAgent || mobileTouch || mobileMedia);
    this.init();
  },
  methods: {
    init() {
      if (!this.isMobile){
        this.initSwiper();
      }
      this.initAos();
    },
    headerFixed() {
      let selectHeader = selectEl("#header");
      if (!selectHeader) {
        setTimeout(() => {
          this.headerFixed();
        }, 100);
        return;
      }
      if (selectHeader) {
        let nextElement = selectHeader.nextElementSibling;
        let headerFixed = null;
        if (this.isMobile) {
          headerFixed = () => {
            selectHeader.classList.add("fixed-top");
            nextElement.classList.add("scrolled-offset");
          };
        } else {
          headerFixed = () => {
            if (window.scrollY >= 16) {
              selectHeader.classList.add("fixed-top");
              nextElement.classList.add("scrolled-offset");
            } else {
              selectHeader.classList.remove("fixed-top");
              nextElement.classList.remove("scrolled-offset");
            }
          };
        }
        window.addEventListener("load", headerFixed);
        onscroll(document, headerFixed);
      }
    },
    initSwiper() {
      console.log("initSwiper", selectEl(".testimonials-slider"));
      const tEl = selectEl(".testimonials-slider");
      if (!tEl) {
        setTimeout(() => {
          this.initSwiper();
        }, 100);
        return;
      }
      new Swiper(".testimonials-slider", {
        speed: 600,
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        slidesPerView: "auto",
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
      });
    },
    initAos() {
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
    },
    scrollto(el) {
      let header = selectEl("#header");
      let offset = header.offsetHeight;

      if (!header.classList.contains("header-scrolled")) {
        offset -= 16;
      }

      let elementPos = selectEl(el).offsetTop;
      window.scrollTo({
        top: elementPos - offset,
        behavior: "smooth",
      });
    },
    goSignUp() {
      location.href = 'https://www.drvoice.cn/v2/conf/1689/home'
      if (this.isCN) {
        //location.href = 'https://www.drvoice.cn/v2/1689/1504/home'
        //location.href = 'https://mm.sciconf.cn/cn/user/login/28866'
      } else {
         //this.$router.push({name: 'sign'})
        //location.href = 'https://mm.sciconf.cn/en/user/login/28866'
      }
    },
    goSubmission(type) {
      if (type) {
        this.$router.push({name:'caseSubmission'})
      } else {
        this.$router.push({name:'essaySubmission'})
      }
    }
  },
  computed:{
    isCN() {
      return this.global.isCN
    }
  }
};
</script>

<style scoped>
.container-mb .scrolled-offset {
  margin-top: 50px;
}
.container-mb #header {
  height: 50px;
  /* background-color: #1015a3; */
  background-image: linear-gradient(to right, #0545b5, #000c60);
  background-color: #fff;
  box-shadow: 0px 2px 15px rgba(0, 0, 0, 0.1);
}
.container-mb #header .navbar .mobile-nav-toggle {
  color: #fff;
  /* color: #193db3; */
}
.container-mb .lang-check {
  color: #193db3;
  background-color: #fff;
  /* border: 1px solid #193db3; */
  border-radius: 4px;
  font-size: 14px;
  line-height: 28px;
  text-align: center;
  width: 78px;
  margin-right: 20px;
  margin-left: 80px;
  font-weight: 700;
}

.container-mb .banner h1 {
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: 26px;
  font-weight: 700;
  color: #222222;
  font-family: "Poppins", sans-serif;
  color: #ffffff;
  background: linear-gradient(
    0deg,
    #ffebb9 0%,
    #ffd867 65.9912109375%,
    #ffeaa7 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.container-mb .banner .yy {
  width: 100%;
  position: absolute;
  top: 36px;
  left: 0;
  color: transparent;
  font-size: 26px;
  font-weight: 700;
  text-shadow: -3px 5px 5px rgba(0, 0, 0, 0.3), -2px -3px 0 #000;
}

.container-mb .banner h2 {
  color: #555555;
  margin: 20px 0 5px 0;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
}
.container-mb .banner .logo img {
  width: 100px;
}
.container-mb #hero .box {
  /* border-top: 1px solid #2c48c8;
    border-bottom: 1px solid #2c48c8; */
}
.container-mb #hero .img-list {
  display: flex;
  align-items: center;
  overflow-y: hidden;
  flex-wrap: nowrap;
}

.container-mb #hero .img-list .img-box {
  border: 1px solid #2c48c8;
  margin: 0 5px;
  list-style: none;
  white-space: nowrap;
  width: 45vw;
  padding: 2vw;
}
.container-mb #hero .img-list img {
  width: 41vw;
}

.container-mb .programe {
  padding-top: 60px;
}
.container-mb .mb-title {
  font-weight: 700;
  font-size: 26px;
  line-height: 3em;
  text-align: center;
  color: #02315a;
}
.container-mb .programe .programe-item {
  display: flex;
  padding: 10px 32px;
  justify-content: space-between;
}
.container-mb .programe .programe-item .item-time {
  font-weight: 700;
  font-size: 20px;
  /* line-height: 2em; */
  color: #444446;
}
.container-mb .programe .programe-item .item-text {
  font-weight: 400;
  font-size: 20px;
  /* line-height: 2em; */
  color: #2a2a2a;
}
.container-mb .programe .programe-item .icon {
  width: 50px;
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #0e6dea;
}
.container-mb .welcoming .p {
  font-size: 17px;
  padding: 0 30px;
  width: 100%;
  margin-bottom: 1em;
  font-family: Source Han Sans SC;
  font-weight: 500;
  color: #666666;
}
.container-mb .welcoming .isfold {
  position: relative;
  height: 188px;
  width: 100%;
  overflow: hidden;
}
.container-mb .welcoming .isfold::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 24px;
  width: 100%;
  background-color: rgb(255, 255, 255, 0.7);
}
.container-mb .welcoming .switch {
  padding: 10px 0;
  text-align: center;
  font-size: 18px;
  line-height: 1em;
  color: #02315a;
}
.container-mb .previews .previews-list {
  display: flex;
  overflow-y: hidden;
  flex-wrap: nowrap;
  padding: 0;
  margin: 0;
}
.container-mb .previews .previews-list .previews-item {
  width: 45vw;
  flex-shrink: 0;
  list-style: none;
  white-space: nowrap;
  border-radius: 10px;
  margin: 10px;
  padding: 10px;
  border: 1px solid #dcdcdc;
}
.container-mb .previews .previews-list img {
  border-radius: 10px;
  width: 100%;
}
.container-mb .previews .previews-list h4 {
  padding-top: 10px;
  font-size: 15px;
  font-weight: 700;
  color: #222120;
  white-space: pre-wrap;
}
.container-mb .previews .previews-list p {
  font-size: 13px;
  white-space: pre-wrap;
  margin: 0;
}
.container-mb .testimonials {
  padding: 20px 0;
  background: none;
}
.container-mb .testimonials .testimonial-item h3 {
  color: #41708c;
}
.container-mb .testimonials .testimonial-item h4 {
  color: #333;
}
.container-mb .testimonials .testimonial-item p {
  margin: 0 auto 15px auto;
  font-style: italic;
  color: #08314f;
}

.container-mb #footer .hosted {
  text-align: center;
}
.container-mb #footer .hosted h5 {
  color: #3498db;
}
.container-mb #footer h5 {
  font-size: 15px;
  color: #2d2d2d;
}
.container-mb #footer p {
  font-size: 13px;
  color: #2d2d2d;
}
.container-mb .foot-bottom {
}
.container-mb .white {
  background: #fff;
  padding: 16px 0 25px;
}
.container-mb .white .foot-item {
  display: flex;
  margin-bottom: 20px;
}
.container-mb .white .foot-item h5,
.container-mb .white .foot-item p {
  margin-bottom: 0;
  line-height: 1.8em;
}

.container-mb .white .foot-item .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100px;
  font-size: 30px;
  line-height: 1em;
  color: #3498db;
}
.container-mb .white .foot-item .item-rt {
  flex: 1;
}
.container-mb .sign-list {
  display: flex;
  text-align: center;
  justify-content: space-around;
}
.container-mb .sign-list img {
  width: 80%;
}
.sign-img {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}

#hero {
  width: 100%;
  position: relative;
  /* padding: 120px 0 0 0; */
  padding: 40px 0 0 0;
  /* padding-top: 20px; */
  background: url("../assets/img/slices/hero-bg.png");
  background-size: cover;
}
.container-mb #hero {
  background-image: linear-gradient(to right, #0545b5, #000c60);
}

/* #hero:before {
  content: "";
  background: rgba(2, 5, 161, 0.91);
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
} */

#hero h1 {
  position: relative;
  z-index: 1;
  margin: 0;
  font-size: 48px;
  font-weight: 700;
  line-height: 64px;
  color: #222222;
  font-family: "Poppins", sans-serif;
  color: #ffffff;
  background: linear-gradient(
    0deg,
    #ffebb9 0%,
    #ffd867 65.9912109375%,
    #ffeaa7 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
#hero .yy {
  position: absolute;
  top: 0;
  left: 0;
  color: transparent;
  font-size: 48px;
  font-weight: 700;
  line-height: 64px;
  text-shadow: -3px 5px 5px rgba(0, 0, 0, 0.3), -2px -3px 0 #000;
}

#hero h2 {
  color: #555555;
  margin: 20px 0 20px 0;
  font-size: 24px;
  font-weight: 400;
  color: #ffffff;
}

#hero .animated {
  animation: up-down 2s ease-in-out infinite alternate-reverse both;
}

@media (min-width: 1024px) {
  #hero {
    background-attachment: fixed;
  }
}

@media (max-width: 991px) {
  #hero {
    /* padding-top: 80px; */
  }
  #hero .text {
    text-align: center;
    width: 100%;
  }
  #hero .hero-img {
    text-align: center;
  }

  #hero .hero-img img {
    max-width: 50%;
  }

  #hero h1 {
    font-size: 23px;
    line-height: 32px;
    margin-bottom: 10px;
  }
  #hero .yy {
    font-size: 23px;
    line-height: 32px;
    margin-bottom: 10px;
    width: 100%;
    text-align: center;
  }

  #hero h2 {
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 30px;
  }
}

@media (max-width: 575px) {
  #hero .hero-img img {
    width: 80%;
  }
}

@-webkit-keyframes up-down {
  0% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(-10px);
  }
}

@keyframes up-down {
  0% {
    transform: translateY(10px);
  }

  100% {
    transform: translateY(-10px);
  }
}

.hero-waves {
  display: block;
  margin-top: 60px;
  width: 100%;
  height: 60px;
  z-index: 5;
  position: relative;
}

.wave1 use {
  -webkit-animation: move-forever1 10s linear infinite;
  animation: move-forever1 10s linear infinite;
  -webkit-animation-delay: -2s;
  animation-delay: -2s;
}

.wave2 use {
  -webkit-animation: move-forever2 8s linear infinite;
  animation: move-forever2 8s linear infinite;
  -webkit-animation-delay: -2s;
  animation-delay: -2s;
}

.wave3 use {
  -webkit-animation: move-forever3 6s linear infinite;
  animation: move-forever3 6s linear infinite;
  -webkit-animation-delay: -2s;
  animation-delay: -2s;
}

@-webkit-keyframes move-forever1 {
  0% {
    transform: translate(85px, 0%);
  }

  100% {
    transform: translate(-90px, 0%);
  }
}

@keyframes move-forever1 {
  0% {
    transform: translate(85px, 0%);
  }

  100% {
    transform: translate(-90px, 0%);
  }
}

@-webkit-keyframes move-forever2 {
  0% {
    transform: translate(-90px, 0%);
  }

  100% {
    transform: translate(85px, 0%);
  }
}

@keyframes move-forever2 {
  0% {
    transform: translate(-90px, 0%);
  }

  100% {
    transform: translate(85px, 0%);
  }
}

@-webkit-keyframes move-forever3 {
  0% {
    transform: translate(-90px, 0%);
  }

  100% {
    transform: translate(85px, 0%);
  }
}

@keyframes move-forever3 {
  0% {
    transform: translate(-90px, 0%);
  }

  100% {
    transform: translate(85px, 0%);
  }
}
.CVH-mb {
  min-height: 100vh;
  background-color: #d9ecf9;
}

.CVH-mb img {
  border: none;
  vertical-align: middle;
  outline: none;
  width: 100%;
}
.CVH-mb .container {
  margin: 0 auto;
  padding: 0 0;
  width: 100%;
}
.CVH-mb .wap-grid {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
}
.CVH-mb .wap-grid-6 {
  width: 50%;
  float: left;
}
.CVH-mb .wap-grid-4 {
  width: 33.33333333%;
  float: left;
}
.CVH-mb .wap-grid-8 {
  width: 66.66666666%;
  float: left;
}
.CVH-mb .wap-grid-12 {
  width: 100%;
  float: left;
}
</style>
